import { IShimmerProps, Shimmer as FluentShimmer, Stack } from "@fluentui/react";
import React from "react";

export type ShimmerProps = IShimmerProps & {
    testId?: string;
};

export const Shimmer: React.FunctionComponent<ShimmerProps> = (props: ShimmerProps) => {
    return (
        <Stack styles={{ root: { width: "100%" }, ...props.styles }} data-testid={props.testId ?? "shimmer-component"}>
            <FluentShimmer {...props} />
        </Stack>
    );
};
